import React from 'react'
import Card from '../Components/Card/Card'
import { EmployerLayout } from '../Layout/EmployerLayout'

const Settings: React.FC = ()=>{


    return(
        <EmployerLayout>
            <div style={{
                display: 'flex', 
                flexDirection: 'row', 
                justifyContent: 'center', 
                alignItems: 'center', 
                flexWrap: 'wrap',
                marginTop: 11
            }}>
             <Card title='تغيير كلمة المرور' to='/employer/settings/change-password' />
             <Card title='معلومات التواصل' to='/employer/settings/info' />
            </div>
        </EmployerLayout>
    )
}

export default Settings